import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  gap: 1rem;
  flex: 1;
  flex-wrap: wrap;

  > .info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 4rem;
    gap: 1rem;
  }
`

export const Title = styled.span`
  font-size: ${(props) => props.theme.font.textcaption};
  color: ${(props) => props.theme.color.neutral.gray};
`

export const Body = styled.div`
  /* display: flex; */
`
